<!-- Modal -->
<div id="myModal" class="modal fade show" role="dialog" [ngStyle]="{'display':display}">
    <div class="modal-dialog modal-lg modal-dialog-centered">
  
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-left">Reply Comment</h5>
          <button (click)="onClose()" type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <textarea #textArea class="form-control" name="" cols="30" rows="10" placeholder="Enter text..."></textarea>
        </div>
        <div class="modal-footer">
          <button (click)="onSubmit()" type="button" class="btn" data-dismiss="modal">Submit</button>
        </div>
      </div>
  
    </div>
  </div>